import type { Maybe } from '@adornis/base/utilTypes.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { projectConfig } from '@chancenwerk/config/config.js';
import { KpfFilter } from '@chancenwerk/shared/filter/KpfFilter.js';
import { KPFAPI } from '@chancenwerk/shared/master-data-management/kpf/api/KPFAPI.js';
import { KPF } from '@chancenwerk/shared/master-data-management/kpf/entities/KPF.js';
import { type AllPermissions, ChancenPermission } from '@chancenwerk/shared/permissions.js';
import { RaumRoutes } from '@chancenwerk/routes/raumRoutes.js';
import { customElement } from 'lit/decorators.js';
import { ChancenComponentSemanticEntityPicker } from './chancen-component-semantic-entity-picker.js';
/**
 * @element chancen-component-semantic-kpf-picker
 */
@customElement('chancen-component-semantic-kpf-picker')
export class ChancenComponentSemanticKpfPicker extends ChancenComponentSemanticEntityPicker<KPF, KpfFilter> {
  protected override _permission: AllPermissions | null = ChancenPermission.raum.EDIT_KPF;
  override placeholder: string = 'KPF';

  protected override _subscription() {
    return KPFAPI.subscribeByFilter;
  }

  protected override _resolveID(id: string): (gqlFields: BaseQLSelectionSet<KPF>) => Promise<Maybe<KPF>> {
    return getByID<typeof KPF>(KPF, id) as any;
  }

  protected override _filter() {
    return KpfFilter;
  }

  protected override _selectionSet() {
    return {
      kuerzel: 1,
      schoolID: 1,
      school: { name: 1, kuerzel: 1 },
      produkt: { name: 1, kuerzel: 1 },
      standardMembershipFee: 1,
    };
  }

  protected override _controlEdit(entity: KPF): void {
    goTo(`${projectConfig.get('RAUM_URL').slice(0, -1)}${RaumRoutes.editKpf}/${entity._id}`, { target: '_blank' });
  }

  protected override _controlNew(): void {
    goTo(`${projectConfig.get('RAUM_URL').slice(0, -1)}${RaumRoutes.editKpf}/new`, { target: '_blank' });
  }
}
